import { render, staticRenderFns } from "./Tab2LabResult.vue?vue&type=template&id=103b9bcc&scoped=true&"
import script from "./Tab2LabResult.vue?vue&type=script&lang=js&"
export * from "./Tab2LabResult.vue?vue&type=script&lang=js&"
import style0 from "./Tab2LabResult.vue?vue&type=style&index=0&id=103b9bcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103b9bcc",
  null
  
)

export default component.exports